/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ConnectedAddTaskTemplate from '../../components/modal/AddTaskTemplate';
import { hasFeatureInLocalStorage } from '../../global/featureFlags';
import {
  createNewTaskTemplate,
  updateTaskTemplate,
  getTaskTemplates,
  getEmaTaskProviders,
  getKareoTaskProviders,
  getDocumentCategories,
  getTaskTemplateCategoryUsage,
} from '../../actions/userProfile';

const TASK_AUTO_UPLOAD_FEATURE = 'task_auto_upload';

class AddTaskTemplateDialog extends Component {
  render() {
    return (
      <div>
        <ConnectedAddTaskTemplate
          {...this.props}
        />
      </div>
    );
  }
}

AddTaskTemplateDialog.propTypes = {
  createNewTaskTemplate: PropTypes.func.isRequired,
  updateTaskTemplate: PropTypes.func.isRequired,
  getTaskTemplates: PropTypes.func.isRequired,
  getEmaTaskProviders: PropTypes.func.isRequired,
};

export default connect(
  (state, ownProps) => ({
    emaTaskTemplates: state.auth.data,
    taskAutoUploadEnabled: ownProps.modalType?.data?.taskAutoUploadEnabled
      ?? hasFeatureInLocalStorage(TASK_AUTO_UPLOAD_FEATURE),
  }),
  {
    createNewTaskTemplate,
    updateTaskTemplate,
    getTaskTemplates,
    getEmaTaskProviders,
    getKareoTaskProviders,
    getDocumentCategories,
    getTaskTemplateCategoryUsage,
  },
)(AddTaskTemplateDialog);
